export default __webpack_public_path__ + "static/media/Dmitri-Particle_0003_IceSpike2.4b4dea48.png";